import { Skeleton } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';

const PLACEHOLDER_ROW_COUNT = 8;

/** Only remote rows load; the owning View keeps title, filters and headers mounted. */
export const TransactionsSkeleton = () => (
    <ul
        className="w-full"
        aria-busy="true"
        {...getNodeTestIdProp('transactions-grid-skeleton')}
    >
        {Array.from({ length: PLACEHOLDER_ROW_COUNT }).map((_, index) => (
            <li
                className="flex items-center gap-4 px-6 py-3.5"
                key={index}
                {...getNodeTestIdProp(`transactions-row-placeholder-${index}`)}
            >
                <div
                    className="flex w-18 flex-col gap-1.5"
                    {...getNodeTestIdProp(
                        `transactions-row-txn-placeholder-${index}`,
                    )}
                >
                    <Skeleton className="h-3 w-16" />
                    <Skeleton className="h-2 w-12" />
                </div>
                <div
                    className="flex min-w-0 flex-1 flex-col gap-1.5"
                    {...getNodeTestIdProp(
                        `transactions-row-seller-placeholder-${index}`,
                    )}
                >
                    <Skeleton className="h-3 w-32" />
                    <Skeleton className="h-2.5 w-56" />
                </div>
                <Skeleton
                    className="h-5 w-16"
                    {...getNodeTestIdProp(
                        `transactions-row-status-placeholder-${index}`,
                    )}
                />
                <div
                    className="flex items-center gap-1.5"
                    {...getNodeTestIdProp(
                        `transactions-row-payment-placeholder-${index}`,
                    )}
                >
                    <Skeleton className="size-6" />
                    <Skeleton className="h-3 w-12" />
                </div>
                <Skeleton
                    className="ms-auto h-3.5 w-14"
                    {...getNodeTestIdProp(
                        `transactions-row-total-placeholder-${index}`,
                    )}
                />
                <Skeleton
                    className="size-3"
                    {...getNodeTestIdProp(
                        `transactions-row-chevron-placeholder-${index}`,
                    )}
                />
            </li>
        ))}
    </ul>
);
